import { boot, update, showNewMessage, shutdown } from '@intercom/messenger-js-sdk';
import { IntercomSettings, UserArgs } from '@intercom/messenger-js-sdk/dist/types';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class IntercomService {
  boot(settings: IntercomSettings): void {
    boot(settings);
  }
  update(args: UserArgs): void {
    update(args);
  }

  showNewMessage(message: string): void {
    showNewMessage(message);
  }

  shutdown(): void {
    shutdown();
  }
}